import { Dispatch } from 'react';
import { useDispatch } from 'react-redux';
import { Button, Form, Space, Upload } from 'antd';
import useNotification from 'antd/es/notification/useNotification';

import { postCouponUser } from '../../../redux/services/adminSlice';
import { alertFail, alertSuccess, downloadBlob } from '../../../helper/common';
import adminApi from '../../../api/adminApi/adminApi';
import { AxiosResponse } from 'axios';
import { MESSAGE } from '../../../utils/textAlert';

const CouponCode = () => {
  const dispatch: Dispatch<any> = useDispatch();
  const [api, showPopup]: any = useNotification();

  // HANDLE FINISH
  const onFinish = async (values: any): Promise<void> => {
    try {
      const res: any = await dispatch(postCouponUser(values?.file));
      if (res?.payload?.status === 'success') {
        alertSuccess(api, '変更が完了しました。');
      } else {
        alertFail(api, '変更に失敗しました。');
      }
    } catch (error) {
      alertFail(api, MESSAGE.SYSTEM_ERROR);
    }
  };

  // HANDLE DUMMY REQUESTS
  const dummyRequest = async ({ onSuccess }: any): Promise<void> => {
    setTimeout((): void => {
      onSuccess('ok');
    }, 0);
  };

  // HANDLE DOWNLOAD COUPON
  const handleDownloadCoupon = async (): Promise<void> => {
    try {
      const res: AxiosResponse<any, any> = await adminApi.downloadCoupon();
      downloadBlob(res, 'coupon_list_export.csv', 'text/csv;charset=utf-8;');
    } catch (error) {
      alertFail(api, MESSAGE.SYSTEM_ERROR);
    }
  };

  return (
    <div className="coupon-code-wrapper">
      {showPopup}
      <div className="coupon-code-content">
        <Button className="btn-coupon" onClick={handleDownloadCoupon}>
          ダウンロード
        </Button>
        <Form name="coupon" onFinish={onFinish} style={{ width: '100%' }}>
          <Space direction="vertical" style={{ width: '100%' }}>
            <Form.Item name="file" valuePropName="file">
              <Upload name="file" maxCount={1} customRequest={dummyRequest} accept=".txt, .csv">
                <div>
                  <Button className="btn-coupon">Upload</Button>
                </div>
              </Upload>
            </Form.Item>
          </Space>
          <div className="btn-accept-coupon">
            <button className="btn-coupon" type="submit">
              保存
            </button>
          </div>
        </Form>
      </div>
    </div>
  );
};

export default CouponCode;
